export const SET_ERROR = 'SPORTSBOOK_HISTORY:SET_ERROR';
export const SET_PERIOD = 'SPORTSBOOK_HISTORY:SET_PERIOD';
export const UPDATE_HISTORY = 'SPORTSBOOK_HISTORY:UPDATE_HISTORY';
export const TOGGLE_LOADING = 'SPORTSBOOK_HISTORY:TOGGLE_LOADING';
export const EXPORT_HISTORY = 'SPORTSBOOK_HISTORY:EXPORT_HISTORY';
export const LOAD_NEXT_PAGE = 'SPORTSBOOK_HISTORY:LOAD_NEXT_PAGE';
export const SET_ANOTHER_PERIOD = 'SPORTSBOOK_HISTORY:SET_ANOTHER_PERIOD';

export const setPeriod = ({ startDate, endDate, period }) => ({
    type: SET_PERIOD,
    payload: {
        period,
        startDate,
        endDate
    }
});

export const setAnotherPeriod = ({ from, until }) => ({
    type: SET_ANOTHER_PERIOD,
    payload: {
        from,
        until
    }
});

export const updateHistory = (data) => ({
    type: UPDATE_HISTORY,
    payload: data
});

export const toggleLoading = (isLoading) => ({
    type: TOGGLE_LOADING,
    payload: isLoading
});

export const exportHistory = (data) => ({
    type: EXPORT_HISTORY,
    payload: data
});

export const loadNextPage = () => ({
    type: LOAD_NEXT_PAGE
});

export const setError = ({ error }) => ({
    type: SET_ERROR,
    payload: { error }
});
